import { CompanyMessage } from '../../../types/CompanyMessage';
import { CustomerCompanyMessage } from '../../../types/CustomerCompanyMessage';
import { SupplierCompanyMessage } from '../../../types/SupplierCompanyMessage';
import { formatCompanyName } from '../helpers/formatCompanyName.helper';
import { ListingWithMore } from '../ListingWithMore/ListingWithMore';

interface CompanyListingProps {
    companies: CustomerCompanyMessage[] | SupplierCompanyMessage[] | CompanyMessage[];
    showCount?: number;
}

export const CompanyListing = ({ companies, showCount }: CompanyListingProps) => {
    if (!companies) {
        return null;
    }
    const formattedCompanies = companies
        .map((company) => formatCompanyName({ company }))
        .filter((company) => company !== null) as string[];

    return <ListingWithMore showCount={showCount}>{formattedCompanies}</ListingWithMore>;
};
